import MatterInformation from "@/components/features/matter/information/MatterInformation";
import { useRedirectIfMatterDeleted } from "@/hooks/useRedirectIfMatterDeleted";
import { retrieveMatterQueryOptions } from "@/lib/data/react-query/matters/matter";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute(
  "/_auth/matters/$matterId/_layout/matter-details/$tab",
)({
  component: RouteComponent,
  validateSearch: z.object({
    insuranceId: z.string().optional(),
    vehicleId: z.string().optional(),
    lostWageId: z.string().optional(),
    statuteOfLimitationsId: z.string().optional(),
    surveyId: z.string().optional(),
  }),
});

function RouteComponent() {
  const { matterId, tab } = Route.useParams();
  const { data: matterDetails } = useSuspenseQuery(
    retrieveMatterQueryOptions(matterId),
  );

  const matterData = matterDetails.data as unknown;
  const isDeletedMatter =
    Array.isArray(matterData) ||
    !(matterData as { id?: string } | undefined)?.id;
  useRedirectIfMatterDeleted({ matterId, isDeletedMatter });
  if (isDeletedMatter) {
    return null;
  }

  const matter = matterDetails.data;
  return <MatterInformation matter={matter} tab={tab} />;
}
